import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { usePersistStore, useStore } from "../store";
import { UserService } from "../services";
import { Password } from "../controls";
import { Link } from "react-router-dom";
import PasswordChecklist from "./PasswordChecklist";
import { Utils } from "../utils";

interface Props {
  show: boolean;
  onHide: () => void;
}

const SetNewPassword: React.FC<Props> = ({ show, onHide }) => {
  const { token } = usePersistStore((s: any) => s);
  const { setSuccessMessage, setIsLoading } = useStore((s: any) => s);
  const [password1, setPassword1] = useState<string>("");
  const [password2, setPassword2] = useState<string>("");
  const [validationMessage, setValidationMessage] = useState<string>("");

  const handleSubmit = async (e: any) => {
    e?.preventDefault();
    if (!password1 || !password2)
      return setValidationMessage("Please provide your password.");

    if (!Utils.checkPasswordStrength(password1).ok)
      return setValidationMessage(
        "Password must be at least 8 characters and include a letter, a number, and a special character.",
      );

    if (password1 !== password2)
      return setValidationMessage("Passwords do not match.");

    setIsLoading(true);
    let result = await UserService.createPassword(token, {
      password: password1,
    });
    if (result?.error) {
      setValidationMessage(result?.error);
      setIsLoading(false);
      return;
    }

    setIsLoading(false);
    setSuccessMessage("Password created successfully.");
    clear();
    onHide();
  };

  const clear = () => {
    setPassword1("");
    setPassword2("");
    setValidationMessage("");
  };

  return (
    <Modal
      className="disputeModal"
      show={show}
      onHide={() => {
        clear();
        onHide();
      }}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title as="h5">Create your password</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-start">
        <div className="mt-3">
          <Password
            label="New password"
            value={password1}
            name="password1"
            onChange={(e: any) => setPassword1(e?.target?.value)}
            showIcon={false}
          />
          <PasswordChecklist value={password1} />
          <Password
            label="Confirm password"
            value={password2}
            name="password2"
            onChange={(e: any) => setPassword2(e?.target?.value)}
            showIcon={false}
          />
        </div>
        {validationMessage && (
          <div className="col-md-12 validation-message mb-2">
            {validationMessage}
          </div>
        )}
        <div className="d-flex gap-2 justify-content-end">
          <button
            type="button"
            className="placeBidModal__cancel"
            onClick={onHide}
          >
            Cancel
          </button>
          <button
            type="button"
            className="placeBidModal__submit"
            onClick={handleSubmit}
          >
            <i className="bi bi-check2-circle" aria-hidden="true" />
            <span>Submit</span>
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SetNewPassword;
